import {
  USERS_FETCH,
  USERS_FETCH_ALL,
  USERS_IS_FETCING,
  USER_EDIT,
  USERS_FILTER,
} from 'constants/users'

export default function accountsReducer(state={
  list: [],
  pageable: {
      sort: {
          'login': 'asc',
          'name': 'asc',
          'email': false,
          'phone': false,
      },
      size: 10,
      page: 0,
      totalPages: 0,
      totalElements: 0,
  }
}, action){
  switch (action.type) {
    case USERS_FETCH:
        return {
          ...state,
          list:action.payload,
        }
    case USERS_FETCH_ALL:
      return {
          ...state,
          list: action.payload,
      }
    case USER_EDIT:
      return {
         ...state,
         list:{
           ...state.list,
           [action.payload.id]:action.payload.data
         },
      }
    case USERS_IS_FETCING:
      return {
        ...state,
        isFetching:action.payload,
      }
      case USERS_FILTER:
          return {
              ...state,
              pageable: {
                  ...state.pageable,
                  ...action.payload,
                  sort: action.payload.sort ? {
                      ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                          ...obj,
                          [i]: false
                      }), {}),
                      ...action.payload.sort
                  } : state.pageable.sort,
              },
          }
    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js